import { ContainerClient } from "@azure/storage-blob";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Button,
	FormGroup,
	Input,
	Label,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Spinner,
} from "reactstrap";
import { Dispatch } from "redux";
import { promiseLandAction } from "../../actions/promiseLandAction";
import {
	DABBackToList,
	DABButton,
	DABDropDown,
	DABTextBox,
	LoadingSpinnerModal,
} from "../../components/dab";
import ManageCategoryService from "../../services/api/manageCategoryService";
import PromiseLandService from "../../services/api/promiseLandService";
import uploadFileToBlob from "../../services/Azure/azureBlob";
import {
	getLoggedUser,
	getLoggedUserId,
	getLoggedUsername,
} from "../../services/selectors/Accounts";
import { showAlert, showAlertWithBacktrack } from "../common/functions";

class Guid {
	static newGuid() {
		return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
			/[xy]/g,
			function (c) {
				var r = (Math.random() * 16) | 0,
					v = c == "x" ? r : (r & 0x3) | 0x8;
				return v.toString(16);
			}
		);
	}
}
let containerClient: any = null;
let sasTokenExpiry: any = null;

const getSasToken = async () => {
	try {
		const response: any =
			await PromiseLandService.promiseLandGenerateSASToken();
		const { sasUrl, expiresOn } = response;
		sasTokenExpiry = new Date(expiresOn);
		return sasUrl;
	} catch (err) {
		console.error("Error fetching SAS token:", err);
		throw new Error("Unable to fetch SAS token.");
	}
};

async function initializeContainerClient() {
	const containerSasUrl = await getSasToken();
	containerClient = new ContainerClient(containerSasUrl);
}

interface PromiseLandProps {
	dispatch: Dispatch<any>;
	promiseLandData: any;
	callback: any;
	id: number;
}

const PromiseLandDetail: React.SFC<PromiseLandProps> = ({
	dispatch,
	promiseLandData,
	callback,
	id,
}) => {
	const history = useHistory();

	let anyVa: any;
	const [isUploadingFile, setUploading] = useState(false);
	const [formSubmit, setFormSubmit] = useState(false);
	const [isBookMark, setIssBookMark] = useState(false);
	const [isReviewPage, setIsReviewPage] = useState(false);
	const [isErrorOnPage, setIsErrorOnPage] = useState(false);
	const [selectedFileName, setSelectedFileName] = useState(null);
	const [fileSelected, setFileSelected] = useState(anyVa);
	const [newFileSelected, isNewFileSelected] = useState(anyVa);
	const [showModal, setShowModal] = useState(false);
	const [isDetailLoaded, setDetailLoaded] = useState(false);
	const [loggedUserName, setLoggedUserName] = useState("");
	const [loggedUser, setLoggedUser] = useState("");
	const [loggedUserId, setLoggedUserId] = useState(-1);
	const [isDirty, setIsDirty] = useState<boolean>(false);
	const [videoTitle, setVideoTitle] = useState("");
	const [description, setDescription] = useState("");
	const [isFileUploaded, setIsFileUploaded] = useState(false);
	const [showCancelModal, setShowCancelModal] = useState(false);
	const [showEditCancelModal, setShowEditCancelModal] = useState(false);
	const [isUploadLoading, setUploadLoading] = useState(false);
	const [showChangeBookModal, setShowChangeBookModal] = useState(false);
	const [pendingBookChange, setPendingBookChange] = useState<{
		index: number;
		value: string;
	} | null>(null);
	const [dropdownList, setDropdownList] = useState<any[]>([]);
	const [selectedCategoryType, setSelectedCategoryType] = useState<any>(null);
	const [uploadedVideoURL, setUploadedVideoURL] = useState("");
	const [uploadedImageURL, setUploadedImageURL] = useState("");
	const [changesBooks, setChangesBookes] = useState(false);
	const [bookData, setBookData] = useState([]);
	const [selectedImgFile, setImageFile] = useState<any>(null);
	const [isImgChange, setIsImgChange] = useState(false);
	const [books, setBooks] = useState<any>([
		{
			book: "",
			ranges: [
				{
					startChapter: "",
					startVerse: "",
					endChapter: "",
					endVerse: "",
					endChapterList: [],
					endVerseList: [],
				},
			],
		},
	]);

	
	
	const [orderNum, setOrderNum] = useState<any>(null);

	React.useEffect(() => {
		const frompath = sessionStorage.getItem("fromPath");
		dispatch(promiseLandAction.promiseLandGetBooks());
		setShowModal(true);
		if (frompath) {
			sessionStorage.removeItem("fromPath");
		}
		if (id !== 0) {
			dispatch(promiseLandAction.promiseLandGetDetail(id));
			setShowModal(true);
		}

		if (loggedUserName.trim() === "") {
			setLoggedUserName(getLoggedUsername);
		}

		if (loggedUserId === -1) {
			setLoggedUserId(getLoggedUserId);
		}
		if (loggedUser.trim() === "") {
			setLoggedUser(getLoggedUser);
		}
	}, []);

	React.useEffect(() => {
		const fetchDropdown = async () => {
			const dropdownList: any =
				await ManageCategoryService.manageCategoryGetAllActiveCategories();
			setDropdownList(dropdownList?.data?.activeCategories);
		};
		fetchDropdown();
	}, []);

	React.useEffect(() => {
		if (promiseLandData?.bookData) {
			setBookData(promiseLandData?.bookData?.books);
		}
	}, [promiseLandData?.bookData]);

	const validateBooks = (books: any[]) => {
  const errors: string[] = [];

  books.forEach((bookGroup, bookIndex) => {
    const { book, ranges } = bookGroup;

    // 🔹 If book is not selected → ignore entire group
    if (!book) return;

    ranges.forEach((range, rangeIndex) => {
      const {
        startChapter,
        startVerse,
        endChapter,
        endVerse,
      } = range;

      const isAnyFieldFilled =
        startChapter !== "" ||
        startVerse !== "" ||
        endChapter !== "" ||
        endVerse !== "";

      // 🔹 User didn't touch this range → valid
      if (!isAnyFieldFilled) return;

      // 🔹 Partial input → invalid
      if (
        startChapter === "" ||
        startVerse === "" ||
        endChapter === "" ||
        endVerse === ""
      ) {
        errors.push(
          `Book ${bookIndex + 1}, Range ${rangeIndex + 1}: Please complete all fields`
        );
        return;
      }

      const sc = parseInt(startChapter, 10);
      const sv = parseInt(startVerse, 10);
      const ec = parseInt(endChapter, 10);
      const ev = parseInt(endVerse, 10);

      // 🔹 Logical order validation
      if (
        ec < sc ||
        (ec === sc && ev < sv)
      ) {
        errors.push(
          `Book ${bookIndex + 1}, Range ${rangeIndex + 1}: End must be after Start`
        );
      }
    });
  });

  return errors;
};


	const uploadVideoToAzure = async (file: File): Promise<string> => {
		setUploadLoading(true);
		if (!containerClient || new Date() > sasTokenExpiry) {
			await initializeContainerClient();
		}

		const fileName = file.name.split(/[/\\]/).pop()!;
		const blobClient = containerClient!.getBlockBlobClient(fileName);

		try {
			const t0 = performance.now();

			await blobClient.uploadBrowserData(file, {
				blobHTTPHeaders: {
					blobContentType: file.type,
					blobCacheControl: "public, max-age=31536000, immutable",
				},
				blockSize: 4 * 1024 * 1024,
				concurrency: 5,
				onProgress: (ev) => console.log("Uploaded bytes:", ev.loadedBytes),
			});

			setUploadedVideoURL(blobClient.url);
			return blobClient.url;
		} catch (error: any) {
			if (error.statusCode === 403 || error.statusCode === 401) {
				console.warn("SAS token expired, retrying...");
				await initializeContainerClient();

				const retryBlobClient = containerClient!.getBlockBlobClient(fileName);
				await retryBlobClient.uploadBrowserData(file, {
					blobHTTPHeaders: {
						blobContentType: file.type,
						blobCacheControl: "public, max-age=31536000, immutable",
					},
					blockSize: 4 * 1024 * 1024,
					concurrency: 5,
					onProgress: (ev) => console.log("Uploaded bytes:", ev.loadedBytes),
				});

				setUploadedVideoURL(retryBlobClient.url);
				return retryBlobClient.url;
			}

			console.error("Upload failed:", error);
			alert("Upload failed. See console for details.");
			throw error;
		} finally {
			setUploadLoading(false);
		}
	};

	const handleVideoFileChange = (event) => {
		const file = event.target.files[0];
		if (!file) return;

		const fileFormat = file.name.split(".").pop().toLowerCase();
		const allowedVideoFormats = ["mp4"];

		if (allowedVideoFormats.includes(fileFormat)) {
			setFileSelected(file);
			isNewFileSelected(true);
			setSelectedFileName(file.name);
		} else {
			event.target.value = "";
			showAlert("Please select an MP4 video file only.", true);
			return;
		}
		setIsDirty(true);
	};

	const handleFileUpload = async (file: any) => {
		setSelectedFileName(file.name);
		setIsImgChange(true);
		setImageFile(file);
	};

	const handleImageFileChange = (event) => {
		const extension = event.target.files[0].name.split(".").pop();
		if (extension === "png" || extension === "jpg" || extension === "jpeg") {
			handleFileUpload(event.target.files[0]);
			isNewFileSelected(true);
		} else {
			event.target.value = null;
			showAlert(
				`Please select a valid image file (${["png", "jpg", "jpeg"].join(
					", "
				)} only).`,
				true
			);
		}
	};

	const getVerseList = (
		bookId: string,
		chapterNum: string
	): { value: string; text: string }[] => {
		const book: any = bookData.find((b: any) => b.bookId.toString() === bookId);
		if (!book) {
			return [];
		}

		const chapter = book.chapters.find(
			(c) => c.chapter.toString() === chapterNum
		);
		if (!chapter) {
			return [];
		}

		return chapter.verses?.map((v) => ({
			value: v.toString(),
			text: v.toString(),
		}));
	};

	const getChapterList = (
		bookId: string
	): { value: string; text: string }[] => {
		const book: any = bookData.find((b: any) => b.bookId.toString() === bookId);
		if (!book) {
			return [];
		}

		return book.chapters?.map((c) => ({
			value: c.chapter.toString(),
			text: `${c.chapter}`,
		}));
	};

	if (promiseLandData) {
		if (promiseLandData.isError && !promiseLandData.isSuccess) {
			if (showModal) {
				setShowModal(false);
			}
			promiseLandData.isError = false;
			if (promiseLandData.status === "Unauthorized") {
				sessionStorage.setItem(
					"fromPath",
					window.location.pathname + window.location.search
				);
				history.push("/401");
			} else {
				showAlert(promiseLandData.status, true);
				setDetailLoaded(true);
			}
			setIsErrorOnPage(false);
		}

		if (!promiseLandData.isError && promiseLandData.isSuccess) {
			if (showModal) {
				setShowModal(false);
			}
		}

		// EXECUTE AFTER SUCCESSFULL SUBMIT
		if (
			showModal &&
			formSubmit &&
			!promiseLandData.isFormSubmit &&
			promiseLandData.isSuccess
		) {
			if (promiseLandData.isSuccess) {
				if (showModal) {
					setShowModal(false);
				}
				window.localStorage.setItem("alertMessage", promiseLandData.status);
				window.location.href = "/contextualmedia";
			}
		}
	}

	const getChapterListFunc = (
		bookId: string
	): { value: string; text: string }[] => {
		const book: any = bookData.find(
			(b: any) => b?.bookId.toString() === bookId.toString()
		);
		if (!book) return [];

		return book?.chapters?.map((ch) => ({
			value: ch.chapter.toString(),
			text: ch.chapter.toString(),
		}));
	};
	const getVerseListFunc = (
		bookId: string,
		chapter: string
	): { value: string; text: string }[] => {
		const book: any = bookData.find(
			(b: any) => b.bookId.toString() === bookId.toString()
		);
		if (!book) return [];

		const chObj = book.chapters.find(
			(ch) => ch.chapter.toString() === chapter.toString()
		);
		if (!chObj) return [];

		return chObj.verses?.map((v) => ({
			value: v.toString(),
			text: v.toString(),
		}));
	};

	React.useEffect(() => {
		const loadDetails = async () => {
			if (
				promiseLandData.isDetailComplete &&
				!isDetailLoaded &&
				promiseLandData.promiseLandInput
			) {
				const input = promiseLandData.promiseLandInput;
				const fileName = input?.uploadedFileUrl
					?.split("/")
					.pop()
					?.split("?")[0];

				setVideoTitle(input?.title);
				setDescription(input?.description);
				setOrderNum(input?.sortOrder);
				setSelectedFileName(fileName);
				setIsFileUploaded(!!fileName);
				setSelectedCategoryType({
					categoryId: input?.categoryId,
					categoryName: input?.categoryName,
					mediaTypeCode: input?.resourceMediaType,
				});

				const booksFromAPI = input.books ?? [];

				const mappedBooks = await Promise.all(
					booksFromAPI.map(async (bookObj: any) => {
						const bookId = String(bookObj.bookId);
						const chapterList = (await getChapterListFunc(bookId)) ?? [];

						const mappedRanges = await Promise.all(
							bookObj.verseRanges?.map(async (range: any) => {
								const {
									startChapter = "",
									endChapter = "",
									startVerse = "",
									endVerse = "",
								} = range;

								let endChapterList = chapterList.filter(
									(ch) => parseInt(ch.value, 10) >= parseInt(startChapter, 10)
								);

								if (
									endChapter &&
									!endChapterList.some(
										(opt) => opt.value === String(endChapter)
									)
								) {
									endChapterList.unshift({
										value: String(endChapter),
										text: String(endChapter),
									});
								}
								endChapterList.unshift({ value: "", text: "" });

								const targetChapter = endChapter || startChapter;
								let verseList = await getVerseListFunc(bookId, targetChapter);

								if (!Array.isArray(verseList)) {
									verseList = [];
								}

								let endVerseList = verseList;
								if (startChapter === endChapter && startVerse) {
									endVerseList = verseList.filter(
										(v) => parseInt(v.value, 10) >= parseInt(startVerse, 10)
									);
								}

								if (
									endVerse &&
									!endVerseList.some((opt) => opt.value === String(endVerse))
								) {
									endVerseList.unshift({
										value: String(endVerse),
										text: String(endVerse),
									});
								}

								endVerseList.unshift({ value: "", text: "" });

								return {
									startChapter: String(startChapter),
									endChapter: String(endChapter),
									startVerse: String(startVerse),
									endVerse: String(endVerse),
									endChapterList,
									endVerseList,
								};
							}) ?? []
						);

						return {
							book: bookId,
							ranges: mappedRanges,
						};
					})
				);

				setBooks(mappedBooks);
				setDetailLoaded(true);

				// Reset flags
				promiseLandData.isSuccess = false;
				promiseLandData.status = null;
			}
		};

		loadDetails();
		setChangesBookes(false);
	}, [promiseLandData, isDetailLoaded]);

	React.useEffect(() => {
		setChangesBookes(true);
	}, [books, videoTitle]);

	const handleSubmit = async (event) => {
		event.preventDefault();

		const validationErrors = validateBooks(books);

		if (validationErrors.length > 0) {
			showAlert(validationErrors[0], true);
			return;
		} else {
			setShowModal(true);
		}
		sessionStorage.removeItem("createPromiseLand");
		const formatedBooksData = books
		  ?.filter(book => book?.book)?.map((book) => ({
			bookId: book?.book,
			verseRanges: book?.ranges?.map((range) => ({
				startChapter: range?.startChapter,
				startVerse: range?.startVerse,
				endChapter: range?.endChapter,
				endVerse: range?.endVerse,
			})),
		}));
		let data = {
			contextualMedia: {
				title: videoTitle,
				authorUserId: parseInt(getLoggedUserId()),
				...(formatedBooksData.length && { books: formatedBooksData }),
				resourceUrl:
					selectedCategoryType?.mediaTypeCode === "video"
						? uploadedVideoURL?.split("?")?.[0]
						: selectedCategoryType?.mediaTypeCode === "image"
							? uploadedImageURL
							: "",
				categoryId: selectedCategoryType?.categoryId,
				sortOrder: orderNum ? parseInt(orderNum) : null,
				description: description ?? "",
				...(id !== 0 && { mediaItemId: id }),
			},
		};
		
		dispatch(promiseLandAction.promiseLandSave(data));
		setFormSubmit(true);
	};

	React.useEffect(() => {
		const eventHandler = (event: BeforeUnloadEvent) => {
			var sessionExpiry = window.localStorage.getItem("SESSIONEXPIRY");
			const inSession = Date.now() < Number(sessionExpiry);
			if (!formSubmit && inSession) {
				event.preventDefault();
				event.returnValue = "";
			}
		};
		if (isDirty) {
			window.addEventListener("beforeunload", eventHandler);
		}
		return () => {
			window.removeEventListener("beforeunload", eventHandler);
		};
	}, [isDirty && !formSubmit]);

	const handleRangeChange = (
		bookIndex: any,
		rangeIndex: any,
		field: any,
		value: any
	) => {
		const updatedBooks = [...books];
		const bookGroup = updatedBooks[bookIndex];
		const range = { ...bookGroup.ranges[rangeIndex] };

		range[field] = value;

		const sc = parseInt(range.startChapter || "0", 10);
		const ec = parseInt(range.endChapter || "0", 10);
		const sv = parseInt(range.startVerse || "0", 10);
		const ev = parseInt(range.endVerse || "0", 10);

		if (field === "startChapter" && ec < parseInt(value, 10)) {
			range.endChapter = "";
			range.endVerse = "";
		}

		if (field === "endChapter" && parseInt(value, 10) < sc) {
			range.endChapter = "";
			range.endVerse = "";
		}

		if (
			(field === "startChapter" ||
				field === "startVerse" ||
				field === "endChapter" ||
				field === "endVerse") &&
			sc === ec &&
			ev < sv
		) {
			range.endVerse = "";
		}

		if (range.startChapter) {
			const allChapters = getChapterList(bookGroup.book);
			let filtered = allChapters.filter(
				(ch) => parseInt(ch.value, 10) >= parseInt(range.startChapter, 10)
			);
			if (
				range.endChapter &&
				!filtered.find((ch) => ch.value === range.endChapter)
			) {
				filtered = [
					{ value: range.endChapter, text: range.endChapter },
					...filtered,
				];
			}
			range.endChapterList = [{ value: "", text: "" }, ...filtered];
		} else {
			range.endChapterList = [];
			range.endChapter = "";
		}

		if (range.endChapter) {
			const allVerses = getVerseList(bookGroup.book, range.endChapter);
			let filteredV = allVerses.filter((v) => {
				if (range.startChapter === range.endChapter) {
					return parseInt(v.value, 10) >= parseInt(range.startVerse || "0", 10);
				}
				return true;
			});
			if (
				range.endVerse &&
				!filteredV.find((v) => v.value === range.endVerse)
			) {
				filteredV = [
					{ value: range.endVerse, text: range.endVerse },
					...filteredV,
				];
			}
			range.endVerseList = [{ value: "", text: "" }, ...filteredV];
		} else {
			range.endVerseList = [];
			range.endVerse = "";
		}

		bookGroup.ranges[rangeIndex] = range;
		setBooks(updatedBooks);
	};

	const addRange = (bookIndex) => {
		const updatedBooks = [...books];
		updatedBooks[bookIndex].ranges.push({
			startChapter: "",
			startVerse: "",
			endChapter: "",
			endVerse: "",
			endChapterList: [],
			endVerseList: [],
		});
		setBooks(updatedBooks);
	};

	const removeRange = (bookIndex, rangeIndex) => {
		const updatedBooks = [...books];
		updatedBooks[bookIndex].ranges.splice(rangeIndex, 1);
		setBooks(updatedBooks);
	};

	const addBookGroup = () => {
		setBooks([
			...books,
			{
				book: "",
				ranges: [
					{
						startChapter: "",
						startVerse: "",
						endChapter: "",
						endVerse: "",
						endChapterList: [],
						endVerseList: [],
					},
				],
			},
		]);
	};

	const removeBookGroup = (index) => {
		const updatedBooks = [...books];
		updatedBooks.splice(index, 1);
		setBooks(updatedBooks);
	};

	const handleUploadVideo = async (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (!fileSelected) return alert("Please select a file.");
		setUploading(true);
		await uploadVideoToAzure(fileSelected);
		setUploading(false);
		isNewFileSelected(false);
		setIsFileUploaded(true);
	};

	const handleUploadImage = async (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (!selectedImgFile) return alert("Please select a file.");
		setUploading(true);
		const coverImageUrl = await uploadFileToBlob(
			selectedImgFile,
			Guid.newGuid(),
			"Image"
		);
		setUploadedImageURL(coverImageUrl);
		setUploading(false);
		isNewFileSelected(false);
		setIsFileUploaded(true);
	};

	const handleLoadCancelModal = () => {
		if (isFileUploaded) {
			const data = {
				id: 0,
				videoUrl: uploadedVideoURL?.split("?")[0],
			};
			setShowModal(true);
			dispatch(promiseLandAction.promiseLandDelete(data));
			setShowCancelModal(false);
			history.goBack();
		} else {
			setShowCancelModal(false);
			history.goBack();
		}
	};

	const handleConfirmCancel = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setShowCancelModal(true);
	};

	const handleEditCancel = (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (uploadedVideoURL || changesBooks) {
			setShowEditCancelModal(true);
		} else {
			history.goBack();
		}
	};

	const applyBookChange = (index: number, value: string) => {
		const updatedBooks = [...books];
		updatedBooks[index].book = value;
		updatedBooks[index].ranges = [
			{
				startChapter: "",
				endChapter: "",
				startVerse: "",
				endVerse: "",
				endChapterList: [],
				endVerseList: [],
			},
		];
		setBooks(updatedBooks);
	};

	const handleBookChange = (index: number, value: string) => {
		const updatedBooks = [...books];

		const hasSelectedData = updatedBooks[index].ranges?.some(
			(range) =>
				range.startChapter ||
				range.endChapter ||
				range.startVerse ||
				range.endVerse
		);

		if (hasSelectedData) {
			setPendingBookChange({ index, value });
			setShowChangeBookModal(true);
		} else {
			applyBookChange(index, value);
		}
	};

	const handleLoadChangeBookModal = () => {
		if (pendingBookChange) {
			applyBookChange(pendingBookChange.index, pendingBookChange.value);
			setPendingBookChange(null);
		}
		setShowChangeBookModal(false);
	};

	const getBookOptions = (currentIndex: number) => {
		const selectedBookIds = books
			.filter((_, i) => i !== currentIndex)
			.map((book) => book.book);

		return [
			{ value: "", text: "Select Book" },
			...bookData
				.filter((b: any) => !selectedBookIds.includes(b.bookId.toString()))
				.map((b: any) => ({
					value: b.bookId.toString(),
					text: b.name,
				})),
		];
	};

	return (
		<>
			<div className="promiseland-detail mb-5">
				{(showModal || (!isDetailLoaded && id !== 0)) && (
					<LoadingSpinnerModal
						isShowModal={showModal || (!isDetailLoaded && id !== 0)}
						modalChange={() => {}}
					/>
				)}
				<div className="card-box m-0">
					{!isBookMark && !isReviewPage && !isDetailLoaded && id === 0 && (
						<>
							<DABBackToList
								onClick={(e) => {
									history.goBack();
								}}
							/>
							<form
								name="createform"
								onSubmit={handleSubmit}
								className="create-form"
							>
								<div className="row mb-3 flex-column">
									<div className="col-6">
										<FormGroup>
											<Label
												htmlFor="categoryType"
												data-testid="categoryType"
												className="col-form-label"
											>
												Category Type
											</Label>
											<Input
												id="categoryTypeSelect"
												type="select"
												className="status-select"
												style={{ lineHeight: 1.3 }}
												value={selectedCategoryType?.categoryName || ""}
												onChange={(e) => {
													const selectedValue = e.target.value;
													const selectedItem = dropdownList.find(
														(item) => item.categoryName === selectedValue
													);
													if (selectedItem) {
														setSelectedFileName(null);
														setFileSelected(anyVa);
														setSelectedCategoryType(selectedItem);
													} else {
														setSelectedCategoryType(null);
													}
												}}
												disabled={isFileUploaded}
											>
												<option hidden>Select Category</option>
												{dropdownList?.map((item) => (
													<option
														value={item.categoryName}
														key={item?.categoryId}
													>
														{item.categoryName}
													</option>
												))}
											</Input>
										</FormGroup>
									</div>
									<div className="col-6">
										<FormGroup>
											<Label
												htmlFor="videoName"
												data-testid="videoName"
												className="col-form-label"
											>
												Title
											</Label>
											<DABTextBox
												type="text"
												id="title"
												data-testid="title"
												isRequired={true}
												isHover={false}
												onChange={(event) => {
													setVideoTitle(event.target.value);
												}}
												value={videoTitle}
												pattern=".*\S.*"
												title="Input cannot be only spaces"
												maxLength={100}
											/>
											{videoTitle?.length >= 100 && (
												<span className="text-warning">
													Character limit met. Maximum 100 characters allowed
												</span>
											)}
										</FormGroup>
									</div>
									<div className="col-6">
										<FormGroup>
											<div className="d-flex gap-2 align-items-center">
												<Label
													htmlFor="orderno"
													className="col-form-label"
													data-testid="orderno"
												>
													Order No
												</Label>
												<span>
													(Note: The system will assign the next sequential
													order number if no value is entered.)
												</span>
											</div>
											<Input
												type="number"
												value={orderNum || ""}
												onChange={(e) => {
													const val = e.target.value;
													if (/^\d*$/.test(val)) {
														if (val.length <= 5) {
															setOrderNum(val);
														}
													}
												}}
												min="1"
												maxLength={5}
												className="no-spinner"
												onKeyDown={(e) => {
													if (["e", "E", "+", "-", "."].includes(e.key)) {
														e.preventDefault();
													}
												}}
											/>
										</FormGroup>
									</div>
									<div className="col-6">
										<FormGroup>
											<Label
												htmlFor="description"
												data-testid="description-label"
												className="col-form-label"
											>
												Description
											</Label>
											<textarea
												id="description-textarea"
												data-testid="description-input"
												className="form-control description-textarea"
												rows={4}
												maxLength={300}
												value={description}
												onChange={(e) => setDescription(e.target.value)}
												aria-describedby="description-help description-counter"
												title="Input cannot be only spaces"
											/>

											{description?.length >= 300 && (
												<div className="mt-1">
													<span className="text-warning">
														Character limit met. Maximum 300 characters allowed
													</span>
												</div>
											)}
										</FormGroup>
									</div>
									{selectedCategoryType?.mediaTypeCode === "video" && (
										<div className="col-6">
											<FormGroup data-testid="videoFileContainer">
												<Label
													data-testid="lblVideoFileCreate"
													htmlFor="videoFile"
													className="col-form-label"
												>
													Video File
												</Label>
												<Input
													type="file"
													name="videoFileUpload"
													id="videoFile"
													accept=".mp4"
													required={!fileSelected && !selectedFileName}
													onChange={(e) => handleVideoFileChange(e)}
												/>
											</FormGroup>
											<small className="text-muted d-block mb-1">
												Allowed file type: MP4 only
											</small>
											{selectedFileName && (
												<div className="mb-1 text-muted">
													Selected file: <strong>{selectedFileName}</strong>
												</div>
											)}
											<div
												className="d-flex align-items-center gap-3 action-btn"
												data-testid="uploadVideobtn"
											>
												<DABButton
													id="upload"
													className={`btn-submit-frm ${
														newFileSelected && !isUploadingFile
															? ""
															: "disabled"
													}`}
													onClick={handleUploadVideo}
													value="Upload File"
												>
													Upload File
												</DABButton>
												{isUploadingFile && (
													<>
														<span>Uploading...</span>
														<Spinner size="sm"></Spinner>
													</>
												)}
											</div>
										</div>
									)}
									{selectedCategoryType?.mediaTypeCode === "image" && (
										<div className="col-6">
											<FormGroup data-testid="videoFileContainer">
												<Label
													data-testid="lblImageFileCreate"
													htmlFor="imageFile"
													className="col-form-label"
												>
													Image File
												</Label>
												<Input
													type="file"
													name="imageFileUpload"
													id="imageFile"
													required={selectedFileName === ""}
													accept="image/png, image/jpeg, image/jpg"
													onChange={(e) => {
														handleImageFileChange(e);
													}}
												/>
											</FormGroup>
											<small className="text-muted d-block mb-1">
												Allowed file type: PNG, JPG, & JPEG only
											</small>
											{selectedFileName && (
												<div className="mb-1 text-muted">
													Selected file: <strong>{selectedFileName}</strong>
												</div>
											)}
											<div
												className="d-flex align-items-center gap-3 action-btn"
												data-testid="uploadVideobtn"
											>
												<DABButton
													id="upload"
													className={`btn-submit-frm ${
														newFileSelected && !isUploadingFile
															? ""
															: "disabled"
													}`}
													onClick={handleUploadImage}
													value="Upload File"
												>
													Upload File
												</DABButton>
												{isUploadingFile && (
													<>
														<span>Uploading...</span>
														<Spinner size="sm"></Spinner>
													</>
												)}
											</div>
										</div>
									)}
								</div>

								{isFileUploaded && (
									<>
										<div>
											{books?.map((bookGroup, bookIndex) => (
												<div
													className="mb-3"
													key={`bookGroup-${bookIndex}`}
													data-testid="selectBooks"
												>
													<div className="row">
														<div className="col-5">
															<div className="row align-items-end">
																<div className="col-8">
																	<label
																		className="form-label"
																		data-testid={`bookTitle${bookIndex + 1}`}
																	>
																		Book
																	</label>
																	<div
																		data-testid={`booksection${bookIndex + 1}`}
																	>
																		<DABDropDown
																			id={`book-${bookIndex}`}
																			value={bookGroup.book}
																			// isRequired={true}
																			onChange={(e) =>
																				handleBookChange(
																					bookIndex,
																					e.target.value
																				)
																			}
																			options={getBookOptions(bookIndex)}
																		/>
																	</div>
																</div>
																<div className="col-4">
																	{books.length > 1 && (
																		<button
																			type="button"
																			title="remove book"
																			className="btn btn-outline-danger mt-2"
																			onClick={() => removeBookGroup(bookIndex)}
																		>
																			<FontAwesomeIcon
																				icon={faMinus}
																				className="me-2"
																			/>{" "}
																			Remove Book
																		</button>
																	)}
																</div>
															</div>
														</div>
														<div className="col-6">
															{bookGroup?.ranges?.map((range, rangeIndex) => (
																<div
																	className="row mb-3"
																	key={`range-${rangeIndex}`}
																>
																	<div className="col-11">
																		<div className="row">
																			<div className="col-md-3">
																				<label
																					className="form-label"
																					data-testid={`startchapterLabel${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					Start Chapter
																				</label>
																				<div
																					data-testid={`startchaptersection${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					<DABDropDown
																						id={`startChapter-${bookIndex}-${rangeIndex}`}
																						value={range.startChapter}
																						isRequired={books.filter(book => book.book).length > 0
}
																						onChange={(e) =>
																							handleRangeChange(
																								bookIndex,
																								rangeIndex,
																								"startChapter",
																								e.target.value
																							)
																						}
																						options={
																							!bookGroup.book
																								? [{ value: "", text: "" }]
																								: [
																										{ value: "", text: "" },
																										...getChapterList(
																											bookGroup.book
																										),
																								  ]
																						}
																					/>
																				</div>
																			</div>

																			<div className="col-md-3">
																				<label
																					className="form-label"
																					data-testid={`startverseLabel${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					Start Verse
																				</label>
																				<div
																					data-testid={`startversesection${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					<DABDropDown
																						id={`startVerse-${bookIndex}-${rangeIndex}`}
																						value={range.startVerse}
																						// isRequired={true}
																						onChange={(e) =>
																							handleRangeChange(
																								bookIndex,
																								rangeIndex,
																								"startVerse",
																								e.target.value
																							)
																						}
																						options={
																							!range.startChapter
																								? [{ value: "", text: "" }]
																								: [
																										{ value: "", text: "" },
																										...getVerseList(
																											bookGroup.book,
																											range.startChapter
																										),
																								  ]
																						}
																					/>
																				</div>
																			</div>

																			<div className="col-md-3">
																				<label
																					className="form-label"
																					data-testid={`endchapterLabel${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					End Chapter
																				</label>
																				<div
																					data-testid={`endchaptersection${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					<DABDropDown
																						id={`endChapter-${bookIndex}-${rangeIndex}`}
																						value={range.endChapter}
																						// isRequired={true}
																						onChange={(e) =>
																							handleRangeChange(
																								bookIndex,
																								rangeIndex,
																								"endChapter",
																								e.target.value
																							)
																						}
																						options={
																							!range.startChapter
																								? [{ value: "", text: "" }]
																								: [
																										{ value: "", text: "" },
																										...getChapterList(
																											bookGroup.book
																										).filter(
																											(ch) =>
																												parseInt(
																													ch.value,
																													10
																												) >=
																												parseInt(
																													range.startChapter,
																													10
																												)
																										),
																								  ]
																						}
																					/>
																				</div>
																			</div>

																			<div className="col-md-3">
																				<label
																					className="form-label"
																					data-testid={`endverseLabel${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					End Verse
																				</label>
																				<div
																					data-testid={`endversesection${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					<DABDropDown
																						id={`endVerse-${bookIndex}-${rangeIndex}`}
																						value={range.endVerse}
																						// isRequired={true}
																						onChange={(e) =>
																							handleRangeChange(
																								bookIndex,
																								rangeIndex,
																								"endVerse",
																								e.target.value
																							)
																						}
																						options={
																							!range.endChapter
																								? [{ value: "", text: "" }]
																								: [
																										{ value: "", text: "" },
																										...getVerseList(
																											bookGroup.book,
																											range.endChapter
																										).filter((v) => {
																											if (
																												range.startChapter ===
																												range.endChapter
																											) {
																												return (
																													parseInt(
																														v.value,
																														10
																													) >=
																													parseInt(
																														range.startVerse,
																														10
																													)
																												);
																											}
																											return true;
																										}),
																								  ]
																						}
																					/>
																				</div>
																			</div>
																		</div>
																	</div>
																	<div className="col-1">
																		{bookGroup.ranges.length > 1 && (
																			<div
																				className="col-md-3"
																				data-testid={`removerangeButton${
																					bookIndex + 1
																				}${rangeIndex + 1}`}
																			>
																				<button
																					type="button"
																					title="remove range"
																					className="btn btn-outline-danger rounded-circle d-flex align-items-center justify-content-center mt-4 form-action-btn"
																					onClick={() =>
																						removeRange(bookIndex, rangeIndex)
																					}
																				>
																					<FontAwesomeIcon icon={faMinus} />
																				</button>
																			</div>
																		)}
																	</div>
																</div>
															))}
														</div>
														<div
															className="col-1 d-flex justify-content-end align-self-end"
															data-testid={`addrangeButton${bookIndex + 1}`}
														>
															<button
																type="button"
																title="add range"
																className="btn btn-outline-primary rounded-circle d-flex align-items-center justify-content-center mb-4 form-action-btn"
																onClick={() => addRange(bookIndex)}
															>
																<FontAwesomeIcon icon={faPlus} />
															</button>
														</div>
													</div>
													<hr></hr>
												</div>
											))}

											<div
												className="text-start mb-3"
												data-testid="addbookButton"
											>
												<button
													type="button"
													title="add book"
													className="btn btn-outline-success"
													onClick={addBookGroup}
												>
													<FontAwesomeIcon icon={faPlus} className="me-2" /> Add
													Book
												</button>
											</div>
										</div>
										<div className="ed-buttons d-flex justify-content-end align-items-center gap-3">
											<div data-testid="cancelButtonContainer">
												<DABButton
													id="backToCreate"
													className={`${isUploadingFile ? "disabled" : ""}`}
													onClick={handleConfirmCancel}
													value="CANCEL"
												>
													CANCEL
												</DABButton>
											</div>

											<div data-testid="createButtonContainer">
												<DABButton
													id="submit"
													className={`btn-submit-frm ${
														isUploadingFile ? "disabled" : ""
													}`}
													value="CREATE"
												>
													Create
												</DABButton>
											</div>
										</div>
									</>
								)}
							</form>
						</>
					)}

					{isDetailLoaded && !isBookMark && !isReviewPage && (
						<div>
							<DABBackToList
								onClick={(e) => {
									history.goBack();
								}}
							/>
							<form
								name="createform"
								onSubmit={handleSubmit}
								className="update-form"
							>
								<div className="row mb-3 flex-column">
									<div className="col-6">
										<FormGroup>
											<Label
												htmlFor="categoryType"
												data-testid="categoryType"
												className="col-form-label"
											>
												Category Type
											</Label>
											<Input
												id="categoryTypeSelect"
												type="select"
												className="status-select"
												style={{ lineHeight: 1.3 }}
												data-testid={"selectCategoryDropdown"}
												value={selectedCategoryType?.categoryName || ""}
												onChange={(e) => {
													const selectedValue = e.target.value;
													const selectedItem = dropdownList.find(
														(item) => item.categoryName === selectedValue
													);
													if (selectedItem) {
														setSelectedFileName(null);
														setFileSelected(anyVa);
														setSelectedCategoryType(selectedItem);
													} else {
														setSelectedCategoryType(null);
													}
												}}
												disabled={isFileUploaded}
											>
												<option hidden>Select Category</option>
												{dropdownList?.map((item) => (
													<option
														value={item.categoryName}
														key={item?.categoryId}
													>
														{item.categoryName}
													</option>
												))}
											</Input>
										</FormGroup>
									</div>
									<div className="col-6">
										<FormGroup>
											<Label
												htmlFor="videoName"
												className="col-form-label"
												data-testid="videoName"
											>
												Title
											</Label>
											<DABTextBox
												type="text"
												id="title"
												data-testid="title"
												isRequired={true}
												isHover={false}
												onChange={(event) => {
													setVideoTitle(event.target.value);
												}}
												value={videoTitle}
												pattern=".*\S.*"
												title="Input cannot be only spaces"
												maxLength={100}
											/>
											{videoTitle?.length >= 100 && (
												<span className="text-warning">
													Character limit met. Maximum 100 characters allowed
												</span>
											)}
										</FormGroup>
									</div>
									<div className="col-6">
										<FormGroup>
											<div className="d-flex gap-2 align-items-center">
												<Label
													htmlFor="orderno"
													className="col-form-label"
													data-testid="orderno"
												>
													Order No
												</Label>
												<span>
													(Note: The system will assign the next sequential
													order number if no value is entered.)
												</span>
											</div>
											<Input
												type="number"
												value={orderNum || ""}
												onChange={(e) => {
													const val = e.target.value;
													if (/^\d*$/.test(val)) {
														if (val.length <= 5) {
															setOrderNum(val);
														}
													}
												}}
												min="1"
												maxLength={5}
												className="no-spinner"
												onKeyDown={(e) => {
													if (["e", "E", "+", "-", "."].includes(e.key)) {
														e.preventDefault();
													}
												}}
											/>
										</FormGroup>
									</div>
									<div className="col-6">
										<FormGroup>
											<Label
												htmlFor="description"
												data-testid="description-label"
												className="col-form-label"
											>
												Description
											</Label>
											<textarea
												id="description"
												data-testid="description-input"
												className="form-control description-textarea"
												rows={4}
												maxLength={300}
												value={description}
												onChange={(e) => setDescription(e.target.value)}
												aria-describedby="description-help description-counter"
												title="Input cannot be only spaces"
											/>
											{description?.length >= 300 && (
												<div className="mt-1">
													<span className="text-warning">
														Character limit met. Maximum 300 characters allowed
													</span>
												</div>
											)}
										</FormGroup>
									</div>
									{/* <div className="col-6">
										<FormGroup data-testid="videoFileContainer">
											<Label
												data-testid="lblVideoFileCreate"
												htmlFor="videoFile"
												className="col-form-label"
											>
												Video File
											</Label>
											<Input
												type="file"
												name="videoFileUpload"
												id="videoFile"
												accept=".mp4"
												required={!fileSelected && !selectedFileName}
												onChange={(e) => handleVideoFileChange(e)}
											/>
										</FormGroup>
										<small className="text-muted d-block mb-1">
											Allowed file type: MP4 only
										</small>
										{selectedFileName && (
											<div className="mb-2 text-muted">
												Selected file: <strong>{selectedFileName}</strong>
											</div>
										)}
										<div className="d-flex align-items-center gap-3 action-btn">
											<DABButton
												id="upload"
												className={`btn-submit-frm ${
													newFileSelected && !isUploadingFile ? "" : "disabled"
												}`}
												onClick={handleUploadVideo}
												value="Upload File"
											>
												Upload File
											</DABButton>
											{isUploadingFile && (
												<>
													<span>Uploading...</span>
													<Spinner size="sm"></Spinner>
												</>
											)}
										</div>
									</div> */}
									{selectedCategoryType?.mediaTypeCode === "video" && (
										<div className="col-6">
											<FormGroup data-testid="videoFileContainer">
												<Label
													data-testid="lblVideoFileCreate"
													htmlFor="videoFile"
													className="col-form-label"
												>
													Video File
												</Label>
												<Input
													type="file"
													name="videoFileUpload"
													id="videoFile"
													accept=".mp4"
													required={!fileSelected && !selectedFileName}
													onChange={(e) => handleVideoFileChange(e)}
												/>
											</FormGroup>
											<small className="text-muted d-block mb-1">
												Allowed file type: MP4 only
											</small>
											{selectedFileName && (
												<div className="mb-1 text-muted">
													Selected file: <strong>{selectedFileName}</strong>
												</div>
											)}
											<div
												className="d-flex align-items-center gap-3 action-btn"
												data-testid="uploadVideobtn"
											>
												<DABButton
													id="upload"
													className={`btn-submit-frm ${
														newFileSelected && !isUploadingFile
															? ""
															: "disabled"
													}`}
													onClick={handleUploadVideo}
													value="Upload File"
												>
													Upload File
												</DABButton>
												{isUploadingFile && (
													<>
														<span>Uploading...</span>
														<Spinner size="sm"></Spinner>
													</>
												)}
											</div>
										</div>
									)}
									{selectedCategoryType?.mediaTypeCode === "image" && (
										<div className="col-6">
											<FormGroup data-testid="videoFileContainer">
												<Label
													data-testid="lblImageFileCreate"
													htmlFor="imageFile"
													className="col-form-label"
												>
													Image File
												</Label>
												<Input
													type="file"
													name="imageFileUpload"
													id="imageFile"
													required={selectedFileName === ""}
													accept="image/png, image/jpeg, image/jpg"
													onChange={(e) => {
														handleImageFileChange(e);
													}}
												/>
											</FormGroup>
											<small className="text-muted d-block mb-1">
												Allowed file type: PNG, JPG, & JPEG only
											</small>
											{selectedFileName && (
												<div className="mb-1 text-muted">
													Selected file: <strong>{selectedFileName}</strong>
												</div>
											)}
											<div
												className="d-flex align-items-center gap-3 action-btn"
												data-testid="uploadVideobtn"
											>
												<DABButton
													id="upload"
													className={`btn-submit-frm ${
														newFileSelected && !isUploadingFile
															? ""
															: "disabled"
													}`}
													onClick={handleUploadImage}
													value="Upload File"
												>
													Upload File
												</DABButton>
												{isUploadingFile && (
													<>
														<span>Uploading...</span>
														<Spinner size="sm"></Spinner>
													</>
												)}
											</div>
										</div>
									)}
								</div>

								{isFileUploaded && (
									<>
										<div>
											{books?.map((bookGroup, bookIndex) => (
												<div
													className="mb-3"
													key={`bookGroup-${bookIndex}`}
													data-testid="selectBooks"
												>
													<div className="row">
														<div className="col-5">
															<div className="row align-items-end">
																<div className="col-8">
																	<label
																		className="form-label"
																		data-testid={`bookTitle${bookIndex + 1}`}
																	>
																		Book
																	</label>
																	<div
																		data-testid={`booksection${bookIndex + 1}`}
																	>
																		<DABDropDown
																			id={`book-${bookIndex}`}
																			value={bookGroup.book}
																			isRequired={books.filter(book => book.book).length > 0
}
																			onChange={(e) =>
																				handleBookChange(
																					bookIndex,
																					e.target.value
																				)
																			}
																			options={getBookOptions(bookIndex)}
																		/>
																	</div>
																</div>
																<div className="col-4">
																	{books.length > 1 && (
																		<button
																			type="button"
																			title="remove book"
																			className="btn btn-outline-danger mt-2"
																			onClick={() => removeBookGroup(bookIndex)}
																		>
																			<FontAwesomeIcon
																				icon={faMinus}
																				className="me-2"
																			/>{" "}
																			Remove Book
																		</button>
																	)}
																</div>
															</div>
														</div>
														<div className="col-6">
															{bookGroup?.ranges?.map((range, rangeIndex) => (
																<div
																	className="row mb-3"
																	key={`range-${rangeIndex}`}
																>
																	<div className="col-11">
																		<div className="row">
																			<div className="col-md-3">
																				<label
																					className="form-label"
																					data-testid={`startchapterLabel${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					Start Chapter
																				</label>
																				<div
																					data-testid={`startchaptersection${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					<DABDropDown
																						id={`startChapter-${bookIndex}-${rangeIndex}`}
																						value={range.startChapter}
																						isRequired={books.filter(book => book.book).length > 0
}
																						onChange={(e) =>
																							handleRangeChange(
																								bookIndex,
																								rangeIndex,
																								"startChapter",
																								e.target.value
																							)
																						}
																						options={
																							!bookGroup.book
																								? [{ value: "", text: "" }]
																								: [
																										{ value: "", text: "" },
																										...getChapterList(
																											bookGroup.book
																										),
																								  ]
																						}
																					/>
																				</div>
																			</div>

																			<div className="col-md-3">
																				<label
																					className="form-label"
																					data-testid={`startverseLabel${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					Start Verse
																				</label>
																				<div
																					data-testid={`startversesection${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					<DABDropDown
																						id={`startVerse-${bookIndex}-${rangeIndex}`}
																						value={range.startVerse}
																						isRequired={books.filter(book => book.book).length > 0
}
																						onChange={(e) =>
																							handleRangeChange(
																								bookIndex,
																								rangeIndex,
																								"startVerse",
																								e.target.value
																							)
																						}
																						options={
																							!range.startChapter
																								? [{ value: "", text: "" }]
																								: [
																										{ value: "", text: "" },
																										...getVerseList(
																											bookGroup.book,
																											range.startChapter
																										),
																								  ]
																						}
																					/>
																				</div>
																			</div>

																			<div className="col-md-3">
																				<label
																					className="form-label"
																					data-testid={`endchapterLabel${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					End Chapter
																				</label>
																				<div
																					data-testid={`endchaptersection${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					<DABDropDown
																						id={`endChapter-${bookIndex}-${rangeIndex}`}
																						value={range.endChapter?.toString() || ""}
																						isRequired={books.filter(book => book.book).length > 0}
																						onChange={(e) =>
																						handleRangeChange(
																							bookIndex,
																							rangeIndex,
																							"endChapter",
																							e.target.value
																						)
																						}
																						options={
																						!range.startChapter
																							? [{ value: "", text: "" }]
																							: [
																							{ value: "", text: "" },
																							...getChapterList(bookGroup.book).filter(
																							(ch) => parseInt(ch.value, 10) >= parseInt(range.startChapter, 10)
																							),
																							]
																						}
																						/>
																				</div>
																			</div>
																			<div className="col-md-3">
																				<label
																					className="form-label"
																					data-testid={`endverseLabel${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					End Verse
																				</label>
																				<div
																					data-testid={`endversesection${
																						bookIndex + 1
																					}${rangeIndex + 1}`}
																				>
																					<DABDropDown
																						id={`endVerse-${bookIndex}-${rangeIndex}`}
																						value={
																							range.endVerse?.toString() || ""
																						}
																						isRequired={books.filter(book => book.book).length > 0}
																						onChange={(e) =>
																							handleRangeChange(
																								bookIndex,
																								rangeIndex,
																								"endVerse",
																								e.target.value
																							)
																						}
																						options={range.endVerseList}
																					/>
																				</div>
																			</div>
																		</div>
																	</div>
																	<div className="col-1">
																		{bookGroup.ranges.length > 1 && (
																			<div
																				className="col-md-3"
																				data-testid={`removerangeButton${
																					bookIndex + 1
																				}${rangeIndex + 1}`}
																			>
																				<button
																					type="button"
																					title="remove range"
																					className="btn btn-outline-danger rounded-circle d-flex align-items-center justify-content-center mt-4 form-action-btn"
																					onClick={() =>
																						removeRange(bookIndex, rangeIndex)
																					}
																				>
																					<FontAwesomeIcon icon={faMinus} />
																				</button>
																			</div>
																		)}
																	</div>
																</div>
															))}
														</div>
														<div
															className="col-1 d-flex justify-content-end align-self-end"
															data-testid={`addrangeButton${bookIndex + 1}`}
														>
															<button
																type="button"
																title="add range"
																className="btn btn-outline-primary rounded-circle d-flex align-items-center justify-content-center mb-4 form-action-btn"
																onClick={() => addRange(bookIndex)}
															>
																<FontAwesomeIcon icon={faPlus} />
															</button>
														</div>
													</div>
													<hr></hr>
												</div>
											))}

											<div
												className="text-start mb-3"
												data-testid="addbookButton"
											>
												<button
													type="button"
													className="btn btn-outline-success"
													onClick={addBookGroup}
												>
													<FontAwesomeIcon icon={faPlus} className="me-2" /> Add
													Book
												</button>
											</div>
										</div>
										<div className="ed-buttons d-flex justify-content-end align-items-center gap-3">
											<div data-testid="cancelButtonContainer">
												<DABButton
													id="backToCreate"
													className={`${isUploadingFile ? "disabled" : ""}`}
													onClick={handleEditCancel}
													value="CANCEL"
												>
													CANCEL
												</DABButton>
											</div>
											<div data-testid="createButtonContainer">
												<DABButton
													id="submit"
													className={`btn-submit-frm ${
														isUploadingFile ? "disabled" : ""
													}`}
													value="SAVE"
												>
													Save
												</DABButton>
											</div>
										</div>
									</>
								)}
							</form>
						</div>
					)}
				</div>
			</div>
			<Modal
				isOpen={showCancelModal || showEditCancelModal}
				backdrop="static"
				centered
				data-testid="deleteModal"
			>
				<ModalHeader>Are you sure you want to cancel?</ModalHeader>
				<ModalBody className="modal-body">
					<form name="cancelPromiselandForm">
						<div
							className="col-form-label"
							data-testid="promiseLandCancelMessage"
						>
							{showEditCancelModal
								? "If you proceed, all changes made to the Contextual Media will be discarded."
								: "If you proceed, the uploaded file will be removed, and all selected entities will be cleared. This action cannot be undone."}
						</div>
					</form>
				</ModalBody>
				<ModalFooter>
					<Button
						type="button"
						color="secondary"
						data-bs-dismiss="modal"
						onClick={() => {
							setShowCancelModal(false);
							setShowEditCancelModal(false);
						}}
						data-testid="cancelFormButton"
					>
						No
					</Button>
					<Button
						type="button"
						color="primary"
						onClick={handleLoadCancelModal}
						data-testid="confirmCancelButton"
					>
						Yes
					</Button>
				</ModalFooter>
			</Modal>
			<Modal
				isOpen={showChangeBookModal}
				backdrop="static"
				centered
				data-testid="confirmbookChangeModal"
			>
				<ModalHeader>Are you sure you want to change the book?</ModalHeader>
				<ModalBody className="modal-body">
					<div
						className="col-form-label"
						data-testid="promiseLandCancelMessage"
					>
						If you proceed, all selected chapter and verse data will be cleared.
						This action cannot be undone.
					</div>
				</ModalBody>
				<ModalFooter>
					<Button
						type="button"
						color="secondary"
						onClick={() => setShowChangeBookModal(false)}
						data-testid="cancelbookChangeBtn"
					>
						No
					</Button>
					<Button
						type="button"
						color="primary"
						data-testid="confirmbookChangeBtn"
						onClick={handleLoadChangeBookModal}
					>
						Yes
					</Button>
				</ModalFooter>
			</Modal>
		</>
	);
};

const mapStateToProps = (state: any) => {
	const { promiseLandData } = state;
	return {
		promiseLandData,
	};
};

export default connect(mapStateToProps)(PromiseLandDetail);
